export const LOAD_COMPROMISSOS = 'LOAD_COMPROMISSOS'
export const PDG_TOGGLE_LOADING = 'PDG_TOGGLE_LOADING'
export const SET_COMPROMISSOS_SECRETARIA = 'SET_COMPROMISSOS_SECRETARIA'
export const SET_LOADING_SECRETARIA = 'SET_LOADING_SECRETARIA'



// WEBPACK FOOTER //
// ./src/store/modules/plano_governo/types.js